import { render, staticRenderFns } from "./bulma_simpletableprops.vue?vue&type=template&id=51d19ee2"
import script from "./bulma_simpletableprops.vue?vue&type=script&lang=js"
export * from "./bulma_simpletableprops.vue?vue&type=script&lang=js"
import style0 from "./bulma_simpletableprops.vue?vue&type=style&index=0&id=51d19ee2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports